
<template>
  <vs-popup
    class="holamundo"
    popup-class="w-9/12"
    title="جدید"
    :active.sync="popupActive"
  >
    <form id="formStepStart" data-vv-scope="step-start">
      <div class="vx-row mb-10 w-full">
        <div class="vx-col flex-inline w-full">
          <span>نام:</span>
          <v-select
            v-model="seletedName"
            :options="CustomSettingNameList"
            class="mb-4"
          ></v-select>
          <template v-if="seletedName">
            مقدار:
            <template
              v-if="CustomSettingName[seletedName.value].type === Boolean"
            >
              <vs-switch color="success" v-model="customSetting.value">
                <span slot="on">ON</span>
                <span slot="off">OFF</span>
              </vs-switch>
            </template>
            <template
              v-else-if="CustomSettingName[seletedName.value].type === Number"
            >
              <vs-input
                v-model="customSetting.value"
                inputmode="numeric"
                class="w-full ltr-input"
              />
            </template>
            <template v-else>
              <vs-textarea
                v-model="customSetting.value"
                rows="6"
                class="w-full"
                :class="{ 'ltr-input': ltrInput }"
              />
              <div class="vx-row w-full">
                <div class="vx-col flex-inline">چپ به راست:</div>
                <div class="vx-col flex-inline">
                  <vs-switch color="success" v-model="ltrInput">
                    <span slot="on">ON</span>
                    <span slot="off">OFF</span>
                  </vs-switch>
                </div>
              </div>
            </template>
          </template>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button
            class="mr-3 mb-2"
            @click.prevent="submitForm"
            :disabled="!seletedName"
            >ایجاد</vs-button
          >
        </div>
      </div>
    </form>
  </vs-popup>
</template>
<style>
</style>
<script>
import { CustomSettingName } from "@/enums.js";
import vSelect from "vue-select";

export default {
  name: "create-custom-setting",
  props: {},
  components: {
    "v-select": vSelect,
  },
  data() {
    return {
      CustomSettingName,
      popupActive: false,
      seletedName: null,
      customSetting: {},
      title: "",
      ltrInput: true,
    };
  },
  computed: {
    CustomSettingNameList: function () {
      let ms = [];
      for (let [key, value] of Object.entries(this.CustomSettingName)) {
        ms.push({ value: key, label: value.title + "-" + value.name });
      }
      return ms;
    },
  },
  methods: {
    submitForm() {
      let loading = this.$vs.loading();
      if (!this.seletedName) {
        return;
      }
      this.customSetting.name = this.seletedName.value;
      if (this.CustomSettingName[this.seletedName.value].type === Boolean)
        this.customSetting.value = (this.customSetting.value && true) || false;
      this.$http
        .post(
          "/api/services/app/CustomSetting/CreateOrEdit",
          this.customSetting
        )
        .then((response) => {
          if (response.data.success == true) {
            this.popupActive = false;
            this.$vs.notify({
              time: 5000,
              color: "success",
              title: "موفق!",
              text: "‌کارمزد با موفقیت ذخیره شد",
            });
            this.$emit("success");
          }
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          this.$vs.loading.close();
        }); //end http
    },
    show(groupId) {
      this.customSetting.CustomSettingGroupId = groupId;
      this.popupActive = true;
    },
  },
  mounted() {},
};
</script>